import { jsx as t, jsxs as l, Fragment as B } from "react/jsx-runtime";
import { LoadingIcon as A } from "../Loading/style.js";
import { ButtonAsLink as D, ButtonContainer as F, LeftIcon as R, ButtonWithIconContent as y, RightIcon as W, ButtonLoading as q } from "./style.js";
import { ButtonSkeletonContainer as K } from "./style.js";
function G({
  children: n,
  url: r,
  target: f,
  type: $,
  onClick: e,
  onMouseLeave: g,
  icon: i,
  iconPosition: s = "right",
  disabled: u,
  inactive: I,
  secondary: L,
  light: k,
  responsive: x,
  sharped: b,
  className: d,
  loading: a,
  rel: j,
  labelText: c,
  iconColor: m,
  isNotLink: v,
  ...C
}) {
  let o = n;
  const S = (h) => {
    if (a) {
      h.preventDefault();
      return;
    }
    e && e(h);
  };
  i && (o = /* @__PURE__ */ l(B, { children: [
    s === "left" && /* @__PURE__ */ t(
      R,
      {
        icon: i,
        "aria-label": c,
        style: { color: m }
      }
    ),
    n && /* @__PURE__ */ t(y, { children: n }),
    s === "right" && /* @__PURE__ */ t(
      W,
      {
        icon: i,
        "aria-label": c,
        style: { color: m }
      }
    )
  ] })), a && (o = /* @__PURE__ */ l(B, { children: [
    n && /* @__PURE__ */ t(y, { children: n }),
    /* @__PURE__ */ t(q, { children: /* @__PURE__ */ t(A, {}) })
  ] }));
  const p = {
    $inactive: I,
    $secondary: L,
    $light: k,
    onClick: e,
    $responsive: x,
    $sharped: b,
    className: d,
    rel: j,
    "aria-busy": a,
    ...C
  };
  return r && !u && !v ? /* @__PURE__ */ t(D, { url: r, target: f, ...p, children: o }) : /* @__PURE__ */ t(
    F,
    {
      disabled: u,
      ...p,
      onClick: S,
      onMouseLeave: g,
      type: $ || "button",
      href: r,
      target: f,
      children: o
    }
  );
}
export {
  G as Button,
  K as ButtonSkeleton
};
